import Vue from 'vue';
import Vue2Storage from 'vue2-storage';

Vue.use(Vue2Storage);
export default {
    mutations: {
        setCity(state, city) {
            state.city = city;
            Vue.$storage.set('city', city);
        },
        setCities(state, cities) {
            state.cities = cities;
            Vue.$storage.set('cities', cities);
        }
    },
    state: {
        city: Vue.$storage.get('city') ? Vue.$storage.get('city') : 366,
        cities: Vue.$storage.get('cities') ? Vue.$storage.get('cities') : [],
    },
    getters: {
        getCity(state) {
            return state.city;
        },
        getCities(state) {
            return state.cities;
        },
    }
}